module.exports = __webpack_public_path__ + "media/images/icons/talk-blue-33bc7ebd500f8580b4bee6ac60e48b93.svg";